import { ENDPOINT_ORDERS, ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const patchOrder = (apiParams) => {
  const { id } = apiParams;
  const params = {
    ...apiParams,
  };

  delete params.id;

  return axiosAuth
    .patch(`${ENDPOINT_ROOT}/${ENDPOINT_ORDERS}/${id}`, params)
    .then((res) => res.data);
};

export default patchOrder;
